import Helper from './Helper';

class Accordion3columns {
  constructor(config = {}) {
    const {
      accordions
    } = config;
    this.trigger = accordions;


    this.accordions = Array.prototype.slice.call(document.querySelectorAll(accordions));
    this.currentEl = null;

    if (this.accordions && this.accordions.length !== 0) {
      this.bindEvents();

      const url = location.href;
      const id = url.split('#');

      if (!!id[1]) {
        const accordionToClick = document.querySelector(`#${id[1]} + .ns-three-col-container`);
        const accordionToScroll = document.querySelector('#' + id[1]);
        const headerOffset = document.querySelector('.header').offsetHeight;
        const elementPosition = accordionToScroll.offsetTop;
        const offsetPosition = elementPosition + headerOffset;
        if (accordionToClick) {
          const accordeonHeader = accordionToClick.querySelector('.ns-three-col-container__col');
          const accordeonHeaderHeight = accordeonHeader.offsetHeight;
          setTimeout(() => {
            accordeonHeader.click();
            window.scrollTo({
              top: (offsetPosition + accordeonHeaderHeight + 67),
              behavior: "smooth"
            });
          }, 1000);
        } else {
          setTimeout(() => {
            window.scrollTo({
              top: (offsetPosition + 67),
              behavior: "smooth"
            });
          }, 1000);
        }
      }
    }
  }

  bindEvents() {


    this.accordions.forEach(el => {

      el.addEventListener('click', (e) => {
        let siblingElement = el;

        if (siblingElement.classList.contains('active')) {
          siblingElement.classList.remove('active');
        } else {

          let accordions = document.querySelectorAll('.ns-three-col-container__item.active');
          for (let i = 0; i < accordions.length; i++) {
          accordions[i].classList.remove('active');
          }
          siblingElement.classList.toggle('active');
        }
      });
    });
  }
}

export default Accordion3columns;
